export default __webpack_public_path__ + "static/media/Wolf's Belt of World's Edge.540d5824.jpg";